/**
 * Options for sketches
 * @module sketchBehaviors
 * @category P5
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Real-time feedback
 * @type {string}
 */
export const REAL_TIME_FEEDBACK = "REAL_TIME_FEEDBACK";

/**
 * Performance highlighting
 * @type {string}
 */
export const PERFORMANCE_HIGHLIGHTING = "PERFORMANCE_HIGHLIGHTING";
